export default {
  workspaceUpdate: [],
  meetingItem: [],
  user: [],
  workspaceComments: [],
};
